
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/requests/[uuid]/phone-verification/[phoneId]",
      function () {
        return require("private-next-pages/requests/[uuid]/phone-verification/[phoneId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/requests/[uuid]/phone-verification/[phoneId]"])
      });
    }
  